import * as types from "./actionsTypes";

export function setBrands(brands) {
  return {
    type: types.SET_BRANDS,
    data: brands,
  };
}

export function resetBrands() {
  return {
    type: types.RESET_BRANDS,
  };
}

export function showLinearBrands(linear) {
  return {
    type: types.SHOW_LINEAR_BRANDS,
    data: linear,
  };
}